<div class="become-instructor-partner-area">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-content bg-color">
                    <h2>Hikayenizi Dijitale Taşıyoruz!</h2>
                    <p>Story Media Dijital ile markanızı dijital dünyada zirveye taşıyın! Sosyal medya yönetimi, içerik
                        üretimi, reklam stratejileri ve daha fazlası ile hedef kitlenize etkili bir şekilde ulaşın.</p>
                    <!-- <a routerLink="/" class="default-btn"><i class='bx bx-plus-circle icon-arrow before'></i><span
                            class="label">Apply Now</span><i class="bx bx-plus-circle icon-arrow after"></i></a> -->
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-image bg-image1">
                    <img src="../../../../assets/story/gallery/1.jpg" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-image bg-image2">
                    <img src="../../../../assets/story/gallery/2.jpg" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="become-instructor-partner-content">
                    <h2> Dijitalde Fark Yaratın!</h2>
                    <p>
                        🔹 Dijital Reklam Yönetimi<br>
                        🔹 Fotoğraf ve Video Prodüksiyon<br>
                        🔹 Sosyal Medya Yönetimi<br>
                        🔹 Web Sitesi Tasarımı<br>
                        🔹 Mobil Uygulama<br>
                        🔹 Marka ve Pazarlama Stratejisi
                    </p>
                    <!-- <a routerLink="/" class="default-btn"><i class='bx bx-plus-circle icon-arrow before'></i><span
                            class="label">Contact Us</span><i class="bx bx-plus-circle icon-arrow after"></i></a> -->
                </div>
            </div>
        </div>
    </div>
</div>